<div class="container-main ">
  <mojo-header></mojo-header>
  <mojo-alert-container data-cy="app-alert"></mojo-alert-container>
  <div class="container-children">
    <router-outlet></router-outlet>
  </div>
  <mojo-footer></mojo-footer>
</div>

<router-outlet name="modal"></router-outlet>
<ng-template [cdkPortalOutlet]="pdfToolTip.pdfTooltip$ | async"></ng-template>
<ng-template [cdkPortalOutlet]="overlayContentService.sidebarPortal$ | async">
</ng-template>
<ng-template [cdkPortalOutlet]="overlayContentService.toolbarPortal$ | async">
</ng-template>
